import { render, staticRenderFns } from "./ownervoice.vue?vue&type=template&id=59373a8a&scoped=true"
import script from "./ownervoice.vue?vue&type=script&lang=js"
export * from "./ownervoice.vue?vue&type=script&lang=js"
import style0 from "./ownervoice.vue?vue&type=style&index=0&id=59373a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@4.47.0__css-load_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59373a8a",
  null
  
)

export default component.exports